import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validators } from "investira.sdk";

// Context
const ConsultaContext = React.createContext();

const initialState = {
  orderBy: false, // true = isin/cnpj || false = default
  exibir_desenquadrado: false,
  dialog: null,
};

// Reducers
const reducers = (state = initialState, action) => {
  if (action.type === "ORDER_BY_CHANGED") {
    return {
      ...state,
      orderBy: action.payload,
    };
  }
  if (action.type === "EXIBIR_DESENQUADRADO_CHANGED") {
    return {
      ...state,
      exibir_desenquadrado: action.payload,
    };
  }
  if (action.type === "DIALOG_CHANGED") {
    return {
      ...state,
      dialog: action.payload,
    };
  }
};

// Dispatchs
const actions = {
  updateOrderBy: (pString) => ({
    type: "ORDER_BY_CHANGED",
    payload: pString,
  }),
  updateExibirDesenquadrado: (pBoolean) => ({
    type: "EXIBIR_DESENQUADRADO_CHANGED",
    payload: pBoolean,
  }),
  updateDialog: (pDialog) => ({
    type: "DIALOG_CHANGED",
    payload: pDialog,
  }),
};

// Custom Hook
export const useConsultaContext = () => React.useContext(ConsultaContext);

export const ConsultaProvider = memo(({ children }) => {
  const [state, dispatch] = React.useReducer(reducers, initialState);

  const handleUpdateOrderBy = (pValue) => {
    dispatch(actions.updateOrderBy(pValue));
  };

  const handleUpdateExibirDesenquadrado = (pValue) => {
    dispatch(actions.updateExibirDesenquadrado(pValue));
  };

  const handleUpdateDialog = (pValue) => {
    dispatch(actions.updateDialog(pValue));
  };

  return (
    <ConsultaContext.Provider
      value={{
        state,
        actions: {
          handleUpdateOrderBy,
          handleUpdateExibirDesenquadrado,
          handleUpdateDialog,
        },
      }}
    >
      {children}
    </ConsultaContext.Provider>
  );
});

export default ConsultaProvider;
